import { createAction, createReducer } from 'deox';

export type ExpandedPanel = 'installments' | 'splitpay' | 'prequalification';

export interface UnifiedWidgets {
  expandedPanel: ExpandedPanel | undefined;
}

const defaultState: UnifiedWidgets = {
  expandedPanel: undefined,
};

export const setExpandedPanel = createAction(
  'SET_EXPANDED_PANEL',
  resolve => (expandedPanel: ExpandedPanel | undefined) =>
    resolve(expandedPanel),
);

export const unifiedWidgetsReducer = createReducer(
  defaultState,
  handleAction => [
    handleAction(setExpandedPanel, (state, { payload: expandedPanel }) => ({
      ...state,
      expandedPanel,
    })),
  ],
);

interface MountedState {
  unifiedWidgets: UnifiedWidgets;
}

export const selectExpandedPanel = (
  state: MountedState,
): ExpandedPanel | undefined => {
  return state.unifiedWidgets.expandedPanel;
};

export default unifiedWidgetsReducer;
